
import { Check } from "lucide-react";

interface FeaturesSectionProps {
  features: string | null | undefined;
}

export function FeaturesSection({ features }: FeaturesSectionProps) {
  if (!features) return null;

  const renderFeaturesList = (featureText: string) => {
    return featureText.split('\n').map((feature, index) => (
      <div key={index} className="flex items-start mb-2">
        <Check className="h-5 w-5 text-green-500 mr-2 flex-shrink-0 mt-0.5" />
        <span>{feature.replace(/^[•-]\s*/, '')}</span>
      </div>
    ));
  };

  return (
    <div className="md:w-1/4 p-6 bg-white border-l border-gray-200 overflow-y-auto">
      <h3 className="text-lg font-semibold mb-3">Key Features</h3>
      <div className="text-gray-700">
        {renderFeaturesList(features)}
      </div>
    </div>
  );
}
